export const BgColors = {
  bgColors: {
    //light white background color variables
    bgPrimary0: "#ffffff",
    bgPrimary100: "#F0F0F0",
    bgPrimary200: "#dedede",
    bgPrimary300: "#A0A0A0",
    bgPrimary400: "#888888",
    bgPrimary500: "#585858",
    bgPrimary600: "#434343",
    bgPrimary900: "#171717",
    bgPrimary1000: "#000000",
    bgRadial:"#e2e1e1",

    bgProgressHover: "#34bf00",
    bgClixBar: "#5d5d5d",
    bgFilter: "#FFFFFF",
    bgPlainBtn: "#FFFFFF",
    bgAiBtn: "#FFFFFF",
    bgAiBtnSelected: "#434343",
    bgAiBtnHover: "#888888",
    bgBoxes: "#ffffff",
    bgCircle: "#ffffff",
    bgBar: "#3F51B5",
    bgMuted: "#F0F0F0",
    bgAnalyseButton: "#43AB1B",
    bgAnalyseCenterC:"#43AB1B",
    bgAnalyseTop: "#FFFFFF",
    bgAnalyseCenter: "#FFFFFF",
    bgAnalyseBtnActive: "#43AB1B",
    bgLoginService: "#194978",
    bgSwitchOn: "#5569ab",
    bgSwitchOff: "#969696",
    bgDeleteBtn: "#DD0D08",
    bgPlayBtn: "#43AB1B",
    bgEditBtn: "#515fb0",
    bgDnd: "#fef8dd",
    bgModal: "#FDE992",
    bgModalError: "#FDECEA",
    bgModalSuccess: "#EDF7ED",
    bgModalWarning: "#FFF3CD",
    bgMenu: "#585858",

    //light status background color variables
    bgStatusError: "#BF1A1A",
    bgStatusTrue: "#3EAA1B",
    bgStatusInfo: "#415C98",

    //light progress background color variables
    bgProgress20: "#DD0D08",
    bgProgress40: "#E46D19",
    bgProgress60: "#EACD2A",
    bgProgress80: "#A1BE23",
    bgProgress100: "#0F800F",
    bgToastProgress: "#43AB1B",
    bgProgress120: "#415C98",
    bgContrastProgress: "#43AB1B",

    // light blue background color variables
    bgBlue50: "#f8fff7",
    bgBlue100: "#F4F7FC",
    bgBlue150: "#e7effc",
    bgBlue200: "#CEE0FF",
    bgBlue300: "#A4C6FF",
    bgBlue1000: "#515fb0",
    bgYellow1000: "#efa90b",

    // light color variables for analysis color buttons
    bgLightGreen: "#90EE90",
    bgLightYellow : "#fae9c8",
    bgLightPink : "#FADADD",
    bgDanger: "#dc3545"
  },
};
